import React from "react";
import { Header, Icon, Label, Segment } from "semantic-ui-react";
import { Link } from "react-router-dom";

/**
 * Seccion de centros (InstitutionSimulator) que el backend devuelve en
 * `data.extras.institutionsSimulator` cuando vertical=simulator y page=1.
 *
 * Se renderiza ENCIMA de la tabla de Users como cards horizontales. Cada
 * card lista los servers vinculados, su admin (si lo tiene) y un link
 * directo a /admin/servers para gestionar el centro.
 */
function CardImage({ src, name }) {
  const [failed, setFailed] = React.useState(false);
  if (!src || failed) {
    return (
      <div className="users-v2-inst-card__image users-v2-inst-card__image--placeholder">
        <Icon name="building outline" size="big" />
      </div>
    );
  }
  return (
    <img
      className="users-v2-inst-card__image"
      src={src}
      alt={name}
      onError={() => setFailed(true)}
    />
  );
}

function ServerRow({ server }) {
  return (
    <div className="users-v2-inst-card__server">
      <Label
        size="mini"
        color={server.active ? "green" : "grey"}
        style={{ minWidth: 64, textAlign: "center" }}
      >
        {server.serverKey || "—"}
      </Label>
      <span className="users-v2-inst-card__server-meta">
        <Icon name="cube" /> {server.simulatorCount} sim
      </span>
      <span className="users-v2-inst-card__server-meta">
        <Icon name="eye" /> {server.visores ?? "—"} vis
      </span>
      {server.admin && (
        <span
          className="users-v2-inst-card__server-meta"
          title={`Admin: ${server.admin.email}`}
        >
          <Icon name="user" />
          {server.admin.email}
        </span>
      )}
    </div>
  );
}

export function UsersV2InstitutionsSimulator({ institutions }) {
  if (!Array.isArray(institutions) || institutions.length === 0) return null;

  return (
    <Segment style={{ marginBottom: "1em" }} className="users-v2-inst-section">
      <Header as="h4" style={{ marginBottom: 12 }}>
        <Icon name="building outline" color="blue" />
        <Header.Content>
          Centros simulator ({institutions.length})
          <Header.Subheader>
            Entidades virtuales (no son Users). Para gestionarlas usa
            <Link to="/admin/servers"> /admin/servers</Link>.
          </Header.Subheader>
        </Header.Content>
      </Header>

      <div className="users-v2-inst-cards">
        {institutions.map((inst) => (
          <div key={inst._id} className="users-v2-inst-card">
            <CardImage src={inst.image} name={inst.name} />
            <div className="users-v2-inst-card__body">
              <div className="users-v2-inst-card__title">
                <strong>{inst.name}</strong>
                <Label size="mini" color="blue" basic>
                  Centro
                </Label>
              </div>
              <div className="users-v2-inst-card__meta">
                <span>
                  <Icon name="mail" />
                  {inst.email}
                </span>
                {inst.address && (
                  <span>
                    <Icon name="map marker alternate" />
                    {inst.address}
                  </span>
                )}
              </div>
              {Array.isArray(inst.servers) && inst.servers.length > 0 && (
                <div className="users-v2-inst-card__servers">
                  {inst.servers.map((s) => (
                    <ServerRow key={String(s.serverId)} server={s} />
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </Segment>
  );
}
